import {connect} from '@store/@common';
import {KpiHistory} from './KpiHistory';
import KpiObservationActions from '@store/kpi/KpiObservationActions';
import {kpiObservations, pageCount} from '@store/kpi/KpiObservation.selectors';
import {authUser} from '@store/auth';

const mapStateToProps = {
  kpiObservations,
  authUser,
  pageCount,
};

const mapDispatchToProps = {
  search: KpiObservationActions.search,
  update: KpiObservationActions.update,
};

export default connect(KpiHistory, mapStateToProps, mapDispatchToProps);
